import { useThemeContext } from '../contexts/ThemeContext';

export type ThemeMode = 'light' | 'dark' | 'system';

/**
 * Custom hook for accessing the global theme state.
 * 
 * @returns Object containing current theme, resolved theme, and setter function
 */
export function useTheme() {
  return useThemeContext();
}
